import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "submit"]

  connect() {
    this.update()
  }

  update() {
    this.submitTarget.disabled = !this.emailTarget.validity.valid
  }
}
